import React from "react";
import { Box, Typography, ThemeProvider, createTheme } from "@mui/material";
import themeObject from "../../styles/theme/theme";

const muiTheme = createTheme(themeObject);

const CookieConsent = () => {
    const PrivacyPolicyURL = "/pages/slug/privacy-policy-scraptrade-com-au";

    return (
        <ThemeProvider theme={muiTheme}>
            <Box
                sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    backgroundColor: "#1A1A1A", // Premium deep dark
                    color: "#FFFFFF",
                    p: { xs: 1.5, sm: 2 },
                    zIndex: muiTheme.zIndex.snackbar + 100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    // No visibility logic, always shown as requested
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        gap: { xs: 1, sm: 3 },
                        maxWidth: "lg",
                        width: "100%",
                        px: 2,
                    }}
                >
                    {/* Icon and Title */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box
                            sx={{
                                width: 32,
                                height: 32,
                                borderRadius: "8px",
                                backgroundColor: muiTheme.palette.primary.main,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "16px",
                            }}
                        >
                            🍪
                        </Box>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                color: "#FFFFFF",
                                fontSize: "0.95rem",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Cookie Policy
                        </Typography>
                    </Box>

                    <Typography
                        variant="body2"
                        sx={{
                            color: "rgba(255, 255, 255, 0.7)",
                            lineHeight: 1.4,
                            fontSize: "0.82rem",
                            textAlign: { xs: "center", sm: "left" },
                            flexGrow: 1,
                        }}
                    >
                        We use cookies to personalize your experience, analyze site traffic, and provide a secure environment for your scrap trading. By continuing to use our platform, you acknowledge our use of cookies to enhance service delivery.
                    </Typography>

                    {/* Policy Link */}
                    <a
                        href={PrivacyPolicyURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: muiTheme.palette.primary.main,
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            textDecoration: "underline",
                            whiteSpace: "nowrap",
                            fontFamily: "inherit",
                        }}
                    >
                        View Privacy Policy
                    </a>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default CookieConsent;
